import { useEffect, useState } from 'react';

import clsx from 'clsx';

import { setMenuLocalStorage } from '@/utils/localStorage/menuLocalStorage';

import type { MenuEntryType } from '@/lib/platform/menu/menu';

import { BottomEntries } from '@/components/layouts/LayoutPlatform/components/Menu/components/BottomEntries';
import { MenuHeader } from '@/components/layouts/LayoutPlatform/components/Menu/components/MenuHeader';
import { TopEntries } from '@/components/layouts/LayoutPlatform/components/Menu/components/TopEntries';

type MenuDesktopProps = {
    stickyMenu: boolean;
    setStickyMenu: React.Dispatch<React.SetStateAction<boolean>>;
};

export function MenuDesktop({ stickyMenu, setStickyMenu }: MenuDesktopProps) {
    const [openDropdown, setOpenDropdown] = useState<MenuEntryType['id']>(null);
    const [isMenuOpen, setIsMenuOpen] = useState(stickyMenu);

    useEffect(() => {
        setMenuLocalStorage(stickyMenu);
    }, [stickyMenu]);

    const toggleStickyMenu = () => {
        setStickyMenu((prevState) => !prevState);
        setMenuLocalStorage(!stickyMenu);
    };

    const handleMouseEnter = () => {
        if (!stickyMenu) {
            setIsMenuOpen(true);
        }
    };

    const handleMouseLeave = () => {
        if (!stickyMenu) {
            setIsMenuOpen(false);
            setOpenDropdown(null);
        }
    };

    return (
        <div
            className={clsx('relative z-10 hidden sm:block', {
                'w-52': stickyMenu,
                'w-[72px]': !stickyMenu
            })}>
            <div
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                data-testid={isMenuOpen ? 'menu-wrapper-open' : 'menu-wrapper-close'}
                className={clsx(
                    'menu-wrapper absolute z-10 flex h-full flex-col overflow-x-hidden p-3 transition-all duration-300',
                    { 'w-52': isMenuOpen, 'w-[72px]': !stickyMenu && !isMenuOpen }
                )}>
                <div className="absolute left-0 top-0 -z-1 h-full w-full bg-[#EBF3FF] dark:bg-[#0E111F]" />

                <MenuHeader
                    isMenuOpen={isMenuOpen}
                    toggleStickyMenu={toggleStickyMenu}
                    data-testid="menu-header"
                />
                <div className="scrollbar flex flex-1 flex-col justify-between gap-4 px-3 pb-3">
                    <TopEntries
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        isMenuOpen={isMenuOpen}
                        stickyMenu={stickyMenu}
                    />
                    <BottomEntries
                        openDropdown={openDropdown}
                        setOpenDropdown={setOpenDropdown}
                        isMenuOpen={isMenuOpen}
                        stickyMenu={stickyMenu}
                    />
                </div>
            </div>
        </div>
    );
}
